<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>Sistema de detección de intrusos a través de un bot de Telegram</p>
    <p>
      Realizado por Pablo López Pérez.<br />
    </p>
    <h3>Tutores</h3>
    <ul>
      <li>
        Gabriel Villarrubia González
      </li>
      <li>
        Juan Francisco De Paz Santana
      </li>
      <li>
        Diego Manuel Jiménez Bravo
      </li>
    </ul>
    <h3>Basado en</h3>
    <ul>
      <li>
        <v-btn href="https://vuejs.org">
          <v-icon left dark>mdi-vuejs</v-icon>
          Vue
        </v-btn>
      </li>
      <li>
        <v-btn href="https://vuetifyjs.com">
          <v-icon left dark>mdi-vuetify</v-icon>
          Vuetify
        </v-btn>
      </li>
      <li>
        <v-btn href="https://firebase.google.com">
          <v-icon left dark>mdi-firebase</v-icon>
          Firebase
        </v-btn>
      </li>
      <li>
        <v-btn href="http://flask.pocoo.org">
          <v-icon left dark>mdi-chili-mild</v-icon>
          Flask
        </v-btn>
      </li>
      <li>
        <v-btn href="https://www.arduino.cc/en/Main/Software">
          <v-icon left dark>mdi-code-not-equal-variant</v-icon>
          Arduino
        </v-btn>
      </li>
      <li>
        <v-btn href="https://www.espressif.com/en/products/hardware/esp32/overview">
          <v-icon left dark>mdi-developer-board</v-icon>
          ESP32
        </v-btn>
      </li>
    </ul>
  </div>
</template>

<script>
// Página principal
// @group Interfaz extra
export default {
  name: "HelloPage",
  props: {
    //Título de la página
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  text-decoration: inherit;
}
</style>
